
<nav mat-tab-nav-bar color="accent" updateLayout dir>
  <a mat-tab-link
    routerLink="/fill-in/personal/details"
    i18n>
    פרטים אישיים
  </a>

  <a mat-tab-link
    routerLink="/fill-in/personal/contact"
    [disabled]="!navigator.canNavigateToUrl('/fill-in/personal/contact')"
    i18n>
    פרטי התקשרות
  </a>
</nav>

<section class="tab-place-holder">
  <router-outlet></router-outlet>
</section>
